import React from 'react'
import { Box, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import Image from './Image'
import { Profile as ProfileType } from '../../types/landingPageV2'

interface Props {
  profile: ProfileType
}

const Profile: React.FC<Props> = ({ profile }) => {
  const { classes } = useStyles()

  return (
    <Box className={classes.box}>
      {profile.profilePicture && (
        <Image asset={profile.profilePicture} className={classes.image} />
      )}
      <Box className={classes.textBox}>
        <Typography className={classes.name}>{profile.name}</Typography>
        {profile.title && (
          <Typography className={classes.title}>{profile.title}</Typography>
        )}
      </Box>
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  box: {
    alignItems: 'center',
    display: 'flex',
  },
  image: {
    height: '3.5em',
    marginRight: '.75em',
    width: '3.5em',
  },
  name: {
    fontSize: '1em',
    fontWeight: 700,
  },
  textBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',

    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
    },
  },
  title: {
    fontSize: '1em',
  },
}))

export default Profile
